import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import {
  BrowserRouter as Router,
  Routes,
  Route,
 
} from "react-router-dom";
import 'font-awesome/css/font-awesome.min.css'

import About from './components/about/About';
import GoogleScholar from './components/GoogleScholar';
import Newspaper from './components/Newspaper';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Login from './components/Login';
import BootstrapNav from './components/BootstrapNav';
 
import ContextAPI from './Context/ContextAPI';
import Researcher2 from './components/Researcher2';
import Alert from './components/Alert';
import AddResearchItem from './components/AddResearchItem';
import AddExperience from './components/AddExperience';
import AddSkill from './components/about/AddSkill';
import AddEdu from './components/about/AddEdu';
import Nav from './components/Nav';
function App() {
  return (
    <div className="">
    <ContextAPI>
    <Router>
  {/* <Navbar/> */}
  {/* <BootstrapNav/> */}
  <Nav/>
  <Alert />

<Routes>
<Route exact path='/' element={<Home/>} />
 <Route exact path='/gt/:gatecat' element={<Researcher2/>} />  
  <Route exact path='/about' element={<About/>} />
<Route exact path='/n/:newsCat' element={<Newspaper/>} />
<Route exact path='/contact' element={<Contact/>} />
<Route exact path='/login' element={<Login/>} />
 
<Route exact path='/g/:cat' element={<GoogleScholar/>} />
{/* <Route exact path='/g/:cat' element={<GoogleScholar/>} /> */}
<Route exact path='/experience' element={<Experience/>} />
<Route exact path='/addResearchItem' element={<AddResearchItem/>} />
<Route exact path='/addExperience' element={<AddExperience/>} />
<Route exact path='/addSkill' element={<AddSkill/>} />
<Route exact path='/addEdu' element={<AddEdu/>} />


</Routes>
<Footer/>
</Router>
</ContextAPI>
    </div>
  );
}

export default App;
